import { atomWithStorage } from 'jotai/utils';

export type ThemeMode = 'light' | 'dark';

export const themeModeAtom = atomWithStorage<ThemeMode>('theme-mode', 'light');
